"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MenuItem = function MenuItem(_ref) {
  var index = _ref.index,
      option = _ref.option,
      name = _ref.name,
      selected = _ref.selected,
      currentValue = _ref.currentValue,
      handleChange = _ref.handleChange;
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: 'menu-item' + (selected ? ' selected' : ''),
    title: option.title,
    disabled: option.disabled,
    onClick: handleChange
  }, name);
};
/** TabMenu */


var _default = function _default(_ref2) {
  var options = _ref2.options,
      value = _ref2.value,
      className = _ref2.className,
      _ref2$elementType = _ref2.elementType,
      elementType = _ref2$elementType === void 0 ? 'div' : _ref2$elementType,
      customChild = _ref2.customChild,
      onChange = _ref2.onChange;
  var isStringArray = options && typeof options[0] === 'string';
  var ChildComponent = customChild || MenuItem;
  return /*#__PURE__*/_react["default"].createElement(elementType, {
    className: 'tab-menu ' + (className || '')
  }, options && options.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement(ChildComponent, {
      key: index,
      index: index,
      option: option,
      name: isStringArray ? option : option.name,
      currentValue: value,
      selected: (isStringArray ? option : option.value) === value,
      handleChange: function handleChange(event) {
        return onChange(isStringArray ? option : option.value, index);
      }
    });
  }));
};

exports["default"] = _default;